// Параметры экрана

/**
 * Минимальная ширина для настолького компьютера.
 */
const SCREEN_DESKTOP = 1400;
/**
 * Минимальная ширина для ноутбука.
 */
const SCREEN_NOTEBOOK = 1100;
/**
 * Минимальная ширина для планшета.
 */
const SCREEN_TABLET = 700;

/**
 * Режимы экрана.
 */
const enum ScreenMode
{
	/** Смартфон */
	MOBILE,
	/** Планшет */
	TABLET,
	/** Ноутбук */
	NOTEBOOK,
	/** Настольный компьютер */
	DESKTOP,
}

/**
 * Слушатель смены режимов экрана.
 */
type screenModeListener = ( mode: ScreenMode ) => void;

/**
 * Слушатели смены режимов экрана.
 */
const screenModeListeners = new Set<screenModeListener>();

/**
 * Текущий режим экрана.
 */
let currentScreenMode: ScreenMode = ScreenMode.DESKTOP;

/**
 * Добавление слушателя.
 */
window.addEventListener( 'resize', onWindowResize );
onWindowResize();

/**
 * Обновить текущий режим экрана в соответствии с шириной.
 * 
 * @returns Режим изменился?
 */
function updateCurrentScreenMode(): boolean
{
	const width = window.innerWidth;
	let mode: ScreenMode;
	
	if ( width < SCREEN_TABLET )
	{
		mode = ScreenMode.MOBILE;
	}
	else if ( width < SCREEN_NOTEBOOK )
	{
		mode = ScreenMode.TABLET;
	}
	else if ( width < SCREEN_DESKTOP )
	{
		mode = ScreenMode.NOTEBOOK;
	}
	else
	{
		mode = ScreenMode.DESKTOP;
	}
	
	if ( mode !== currentScreenMode )
	{
		currentScreenMode = mode;
		
		return true;
	}
	
	return false;
}

/**
 * При изменении размеров экрана.
 */
function onWindowResize(): void
{
	if ( updateCurrentScreenMode() )
	{
		screenModeListeners.forEach(
			( listener: screenModeListener ) => listener( currentScreenMode ),
		);
	}
}

/**
 * Добавляет слушателя изменения режима экрана.
 * Первый вызов слушателя автоматический после добавления.
 * 
 * @param listener Слушатель, получает новый `ScreenMode`.
 */
function addScreenModeListener( listener: screenModeListener ): void
{
	screenModeListeners.add( listener );
	listener( currentScreenMode );
}

/**
 * Удаляет слушателя изменения режима экрана.
 * 
 * @param listener Удаляемый слушатель.
 */
function removeScreenModeListener( listener: screenModeListener ): void
{
	screenModeListeners.delete( listener );
}

/**
 * Возвращает текущий режим экрана.
 */
function getCurrentScreenMode(): ScreenMode
{
	updateCurrentScreenMode();
	
	return currentScreenMode;
}

/**
 * Module
 */
export {
	SCREEN_DESKTOP,
	SCREEN_NOTEBOOK,
	SCREEN_TABLET,
	ScreenMode,
	getCurrentScreenMode,
	screenModeListener,
	addScreenModeListener,
	removeScreenModeListener,
};



// WEBPACK FOOTER //
// ./app/utils/Screen.ts